import React, { PureComponent } from 'react';
import moment from 'moment';
import cache from './api/cache.js';
import DateRange from './components/DateRange.js';

import './DateWrap.scss';

// I think I want the date in the URL.. That way it can be pasted?  I'm not sure though..
// Getting cache working would be enough.  I should put a console log in its constructor.

export default function (component) {
	var Comp = component;
	
	return class extends PureComponent {
		constructor(props) {
			super(props);
			cache.init('daterange.start',  moment().startOf('year').toDate());
			cache.init('daterange.end',  moment().endOf('year').toDate());
			cache.init('daterange.selection', 'current_year');
			this.state = {
				start: cache.get('daterange.start'),
				end: cache.get('daterange.end'),
				selection: cache.get('daterange.selection')
			};
		}
		
		onRangeChange = (selection, start, end) => {
			cache.set('daterange.start', start);
			cache.set('daterange.end', end);
			cache.set('daterange.selection', selection);

			this.setState({start: start, end: end});
		}
		
		render() {
			return <div className="DateWrapped">
					<div className="RangeSelector">
						<DateRange label="Data range:" onRangeChange={this.onRangeChange} StartDate={this.state.start} EndDate={this.state.end} Selection={this.state.selection} />
					</div>
					<Comp dateStart={this.state.start} dateEnd={this.state.end} {...this.props} />
				</div>;
		}
	}
}
